import React from 'react';

import { Box, Button, Dialog, DialogActions } from '@mui/material';

import { WarningIcon } from '~/components/icons';
import { IConfigurationSuggestion } from '~/domain/IConfigurationSuggestion';

import { ConfigurationSuggestion } from './ConfigurationSuggestion';
import { DialogSubTitle, DialogTitle } from './styled';

export const ConfigurationSuggestionDialog: React.FC<IConfigurationSuggestionDialog> = (props) => {
  const { suggestChanges, onCancel, onAccept } = props;

  return (
    <Dialog
      open
      PaperProps={{
        sx: {
          width: 570,
          maxHeight: 544,
          p: '34px 40px 40px 40px',
          alignItems: 'center',
        },
      }}
      onClose={(_, reason) => {
        reason === 'escapeKeyDown' && onCancel();
      }}
    >
      <WarningIcon
        sx={{
          width: 25,
          height: 22,
          path: {
            fill: '#DC7D29',
          },
        }}
      />
      <DialogTitle sx={{ mt: 2 }}>
        Configuration Conflicts
      </DialogTitle>
      <DialogSubTitle>
        The updated option requires additional configuration changes. Please review and accept the changes to continue.
      </DialogSubTitle>
      <Box sx={{ mt: '30px', width: '100%', overflow: 'auto' }}>
        {
          suggestChanges.map(suggestChange => (
            <ConfigurationSuggestion
              key={suggestChange.packName}
              packName={suggestChange.packName}
              oldValue={suggestChange.oldValue}
              newValue={suggestChange.newValue}
            />
          ))
        }
      </Box>
      <DialogActions>
        <Button autoFocus color="secondary" size="small" onClick={onCancel}>Cancel</Button>
        <Button color="dark" size="small" onClick={onAccept}>Accept</Button>
      </DialogActions>
    </Dialog>
  )
}

interface IConfigurationSuggestionDialog {
  suggestChanges: IConfigurationSuggestion[];
  onCancel: () => void;
  onAccept: () => void;
}

